import { useLci3CampaignsParams } from '@components/Stats/useApprovals';
import { UpdateCampaignParams } from '@features/campaigns';
import { Switch } from '@mui/material';
import { enqueueSnackbar } from 'notistack';

export type ArchiveToggleProps = {
  campaignId: number;
  archived: boolean;
  updateCampaign: (params: UpdateCampaignParams) => {
    unwrap: () => Promise<unknown>;
  };
};

export const ArchiveToggle = (props: ArchiveToggleProps) => {
  const getCampaignsParams = useLci3CampaignsParams();

  const handleChange = async (archived: boolean) => {
    try {
      await props
        .updateCampaign({
          id: props.campaignId,
          archived,
          getCampaignsParams,
        })
        .unwrap();
      enqueueSnackbar('Campaign archive status updated', {
        variant: 'success',
      });
    } catch (error) {
      console.error(error);
      enqueueSnackbar('Failed to update archive status', {
        variant: 'error',
      });
    }
  };

  return (
    <Switch
      checked={props.archived}
      onChange={(_e, checked) => void handleChange(checked)}
    />
  );
};
